module.exports = __webpack_public_path__ + "static/media/traffic-cone.bfb200b4.svg";